const SERVER_API = 'api/v1/';

class EcDeployPersistenceService {
    constructor(config, $rootScope, crudService, sharedPersistenceService, storageService) {
        this._crudService = crudService;
        this._sharedPersistence = sharedPersistenceService;
        this.$rootScope = $rootScope;
        this.registryUrl = config.registryUrl;
        this.storageService = storageService
        this.REST_ENDPOINTS = this._sharedPersistence.getRestEndpoints();
    }

    getSubscriptions() {
        return this._crudService.get(this.registryUrl + SERVER_API + this.REST_ENDPOINTS.SCOPE_REST + '/subscriptions', false, false, false, false, true, true, true).then(res => {
            this.subscriptionTableState = { searchBy: '' };
            return res.data.entities[0].subscriptions;
        });
    }

    getResourceGroupsFromAzure(uuid) {
        let url = this.registryUrl + SERVER_API + 'subscriptions/' + uuid + '/resourceGroups/azure/dropDown';
        return this._crudService.get(url, null, null, null, null, true, true, false).then(res => {
            this.resourceGroupTableState = { searchBy: '' };
            return res.data.entities;
        })
    }

    getLocations(managerUrl, subscriptionId) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/locations';
            return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
                this.locationTableState = { searchBy: '' };

                return res.data.entities;
            })
        }
        else {
            return this._crudService.get('locations', null, null, null, null, false, false, true).then(res => {
                return res.data.entities;
            })
        }
    }

    getAvailabilityZone(managerUrl, subscriptionId, locationUuid) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/locations/' + locationUuid + '/availabilityZones';
            return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
                this.availabilityZoneTableState = { searchBy: '' };
                return res.data.entities;
            })
        }
        else {
            return this._crudService.get('/locations/' + locationUuid + '/availabilityZones', null, null, null, null, false, false, true).then(res => {
                return res.data.entities;
            })
        }
    }

    getVMType(data) {
        let zone = '';
        if (data.availabilityZone) {
            zone = 'availabilityZones/' + data.availabilityZone + '/';
        }
        return this._crudService.get(data.managerUrl + SERVER_API + `subscriptions/${data.subscriptionId}/locations/${data.locationId}/${zone}virtualMachinesSizes`, null, null, null, data.params, true, true, false).then(resp => {
            return resp.data.entities;
        });
    }

    getVirtualNetworks(managerUrl, subscriptionId, locationName) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/virtualNetworks/azure?filter=location==' + locationName;
            return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
                return res.data.entities;
            })
        }
        else {
            return this._crudService.get('virtualNetworks/azure?filter=location==' + locationName, null, null, null, null, false, false, true).then(res => {
                return res.data.entities;
            })
        }
    }

    startDeploy(managerUrl, subscriptionId, resourceGroupId, data) {
        let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/resourceGroups/' + resourceGroupId + '/ec/deploy';
        return this._crudService.post(url, data, null, null, null, null, true).then(res => {
            return res;
        })
    }

    getExternalAddresses(subscription, location, availabilityZone) {
        let url = subscription.managerEndpointUrl + SERVER_API + 'subscriptions/' + subscription.value + '/publicIPAddresses/azure?filter=availabilityZones==' + availabilityZone + '&filter=location==' + location;
        return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
            return res.data.entities;
        })
    }
}

EcDeployPersistenceService.$inject = ['config', '$rootScope', 'crudService', 'sharedPersistenceService', 'storageService'];

module.exports = EcDeployPersistenceService;



// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/ecDeploy/ecDeploy.persistence.service.js